import type { Theme } from '@ori-ui/mui';
import { styled } from '@ori-ui/mui';
import type { FC } from 'react';

interface ShadeElementProps {
  colorHexCode: string | null;
  colorImageSrc: string | null;
}

const shadeElementStyles = (theme: Theme) =>
  ({
    borderRadius: '50%',
    display: 'inline-block',
    height: 7,
    margin: theme.spacing(1, 1, 1.2, 0),
    width: 7,
  } as const);

const ColorShadeElement = styled('div')<{ ownerState: { background: string } }>(
  ({ theme, ownerState: { background } }) => ({
    ...shadeElementStyles(theme),
    background,
  }),
);

const ImageShadeElement = styled('img')(({ theme }) => shadeElementStyles(theme));

const getLinearGradient = (colors: string[]) =>
  `linear-gradient(to right, ${colors[0]}, ${colors[0]} 50%, ${colors[1]} 50%)`;

export const ShadeElement: FC<ShadeElementProps> = ({ colorHexCode, colorImageSrc }) => {
  const colorHexCodes = colorHexCode?.split(',').filter((hexCode) => Boolean(hexCode));

  if (colorHexCodes && colorHexCodes.length > 0) {
    let ownerState;

    if (colorHexCodes.length > 1) {
      ownerState = { background: getLinearGradient(colorHexCodes) };

      return <ColorShadeElement ownerState={ownerState} />;
    }

    ownerState = { background: colorHexCodes[0] as string };

    return <ColorShadeElement ownerState={ownerState} />;
  }

  if (colorImageSrc) {
    return (
      <ImageShadeElement
        src={colorImageSrc}
        alt=""
      />
    );
  }

  return null;
};
